module.exports = __webpack_public_path__ + "static/media/dimm-img1.7b23fe79.svg";